<template>
  <div>
    <b-row class="my-3">
      <b-col sm="12">
        <b-card class="chr-card-tour">
          <b-card-header>
            <div class="d-flex justify-content-between ">
              <h4>{{ result.name }}</h4>
              <div class="tour-price" v-if="minPrice">
                <small>de la</small> {{ minPrice }} {{ result.dates[0].currency }}
              </div>
            </div>
            <p class="tour-name" style="white-space: pre-line;">{{ result.description }}</p>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col sm="6">
                <h6>Servicii incluse</h6>
                <p class="p-0 ml-3" style="white-space: pre-line;">
                  {{ result.included }}
                </p>
              </b-col>
              <b-col sm="6">
                <h6>Servicii neincluse</h6>
                <p class="p-0 ml-3" style="white-space: pre-line;">
                  {{ result.not_included }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h6 class="border-0" v-translate>Departure dates</h6>
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <td v-translate>Date</td>
                      <td v-translate>Price</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(depDate, depDateIndex) in result.dates"
                      :key="'date' + depDateIndex"
                      :class="{
                        selected: selectedDate && depDate.date == selectedDate.date
                      }"
                      >
                      <td>{{  depDate.date }}</td>
                      <td>
                        <template v-if="depDate.price">
                          de la {{ depDate.price }} {{ depDate.currency }}
                        </template>
                        <template v-else>
                          &euro;0.00
                        </template>
                      </td>
                      <td class="text-right">
                        <b-button variant="warning" size="sm"
                          @click="selectDate(depDate)"><span v-translate>QUOTE</span></b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
              <b-col sm="12" v-if="selectedDate">
                <b-card>
                  <h5>{{ result.name }}, {{ selectedDate.date }}</h5>
                  <b-row>
                    <b-col md="3" v-for="(room, i) in rooms" :key="'room' + i">
                      <b-form-group
                        :label="$gettext('Room') + ' ' + (i + 1)"
                        label-class="chr-label"
                        class=""
                      >
                        <room
                          v-model="rooms[i]"
                          :id="i"
                          :showDelete="i && (rooms.length > 1)"
                          :showAdd = "!i && (rooms.length < 3)"
                          @add = "onRoomAdd"
                          @delete = "onRoomDelete(i)">
                        </room>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="mt-0 mb-2">
                  <b-col sm="12"><hr></b-col>
                    <b-col sm="12" class="d-flex align-items-center justify-content-end">
                      <b-button variant="warning" size="sm" @click="search()"><b-icon icon="search" /><span class="ml-2" v-translate>Search Tours</span></b-button>
                    </b-col>
                  </b-row>
                  <template v-if="searchIsDone">
                    <b-table-simple class="table" responsive small style="font-size: 0.9rem;">
                      <ResultsHeader transport="params.transport" :displayToggle="false"/>
                      <template
                      v-for="(result,resultIndex) in results">
                      <PackageResult
                        v-for="(pack, packIndex) in result.packages"
                        :key="'pack' + resultIndex + packIndex"
                        :result="result"
                        :pack="pack"
                        :allMealsCollapsed="false"
                        :allCategoriesCollapsed="false"
                        :transport="params.transport"
                        :selected="false"
                        :displaySelection="false"
                        @info="onInfo([result])"
                        @book="onBook({ resultId: result.id, packageId: pack.id, ...$event })"
                        @priceDetails="onPriceDetails({ result, pack, ...$event })"
                      />
                      </template>
                    </b-table-simple>
                  </template>
                </b-card>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!-- detail modal -->
    <b-modal v-model="modal" :title="$gettext('Modal Info')" size="xl" hide-header hide-footer>
      <div id="printArea">
        <ModalHeader @print="onPrint()" @download="onDownload()" @closeModal="onModalClose" />
        <b-card class="bg-light" no-body>
          <SearchParamsSummary :params="lastSearchParams"/>
        </b-card>
        <b-row v-for="res in infoResults" :key="'detailedInfo' + res.id" class="p-4">
          <DetailedInfo
            :result="res"
            :currency="result.currency"
          ></DetailedInfo>
        </b-row>
      </div>
      <ModalFooter @closeModal="onModalClose" />
    </b-modal>
    <!-- price details modal -->
    <!-- price details modal -->
    <b-modal v-model="priceDetailsModal" :title="$gettext('Price Details')" size="xl" hide-header hide-footer>
      <SimpleModalHeader @closeModal="closePriceDetailsModal" />
      <PriceDetails
        :result="priceDetailsParams.result"
        :title="priceDetailsParams.title"
        :meal="priceDetailsParams.meal"
        :serviceTax="priceDetailsParams.serviceTax"
        :discounts="priceDetailsParams.discounts"
        :paymentSchedule="priceDetailsParams.paymentSchedule"
      />
      <ModalFooter @closeModal="closePriceDetailsModal" />
    </b-modal>
  </div>
</template>

<script>
import viewMixin from '@/app/private/shared/mixins/search_views'

import { paymentSchedule } from 'b2b-common/services/api/package'

import SimpleModalHeader from '@/app/private/shared/components/simple_modal_header'
import ModalHeader from '@/app/private/shared/components/modal_header'
import ModalFooter from '@/app/private/shared/components/modal_footer'
import PriceDetails from '@/app/private/shared/components/price_details'
import DetailedInfo from '@/app/private/package/components/detailed_info'
import room from '@/app/private/shared/components/search_form_room'
import ResultsHeader from '@/app/private/shared/components/results_table_head'
import PackageResult from '@/app/private/package/components/package_result'
import SearchParamsSummary from '@/app/private/package/components/search_params_summary.vue'

export default {
  name: 'Result',
  mixins: [viewMixin],
  components: {
    room,
    PackageResult,
    ResultsHeader,
    SimpleModalHeader,
    ModalFooter,
    PriceDetails,
    ModalHeader,
    DetailedInfo,
    SearchParamsSummary
  },
  props: {
    result: {
      type: Object,
      mandatory: true
    },
    params: {
      type: Object,
      mandatory: true
    },
    results: {
      type: Array,
      mandatory: false,
      default: () => []
    },
    searchIsDone: {
      type: Boolean,
      mandatory: false,
      default: false
    },
    selectedDate: {
      type: Object,
      mandatory: false,
      default: null
    },
    hasTransport: {
      type: Boolean,
      mandatory: false,
      default: false
    }
  },
  data () {
    return {
      rooms: [{ adults: 2, ages: [] }],
      priceDetailsParams: {
        result: {},
        meal: null,
        title: null,
        discounts: [],
        paymentSchedule: []
      },
      lastSearchParams: {}
    }
  },
  computed: {
    minPrice () {
      return this.result.dates.reduce((prev, curr) => {
        if (!curr) return prev
        if (curr < prev) return curr
        return prev
      }, null)
    }
  },
  methods: {
    onRoomAdd () {
      this.rooms.push({ adults: 2, ages: [] })
    },
    onRoomDelete (index) {
      this.rooms.splice(index, 1)
    },
    onBook ({ resultId, packageId, categoryId, mealIndex }) {
      let pType = this.params.packageType
      pType = pType[0].toUpperCase() + pType.slice(1)
      const route = {
        name: 'Private/' + pType + '/Book',
        params: {
          Result: resultId,
          Package: packageId,
          Category: categoryId,
          Meal: mealIndex
        }
      }
      this.$router.push(route)
    },
    async onPriceDetails ({ result, pack, category, meal }) {
      this.priceDetailsParams.result = result
      this.priceDetailsParams.title = pack.name
      this.priceDetailsParams.meal = meal
      this.priceDetailsParams.discounts = []
      if (Array.isArray(category.discounts)) this.priceDetailsParams.discounts = this.priceDetailsParams.discounts.concat(category.discounts)
      if (Array.isArray(pack.discounts)) this.priceDetailsParams.discounts = this.priceDetailsParams.discounts.concat(pack.discounts)
      this.priceDetailsParams.paymentSchedule = await paymentSchedule({
        packageType: this.params.packageType,
        category: category.id,
        meal: meal.id
      })
      this.priceDetailsModal = true
    },
    selectDate (depDate) {
      this.$emit('select', depDate)
    },
    async search () {
      const params = {
        currency: this.result.currency,
        packageType: this.params.packageType,
        rooms: this.rooms,
        date: this.selectedDate.unix,
        duration: this.result.duration,
        resort: this.result.destination,
        country: null,
        area: null,
        departure: this.params.departure,
        transport: this.params.transport,
        hotel: 'INH' + this.result.hotel
      }
      this.lastSearchParams = params
      this.$emit('search', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.selected {
  background-color: lightcyan;
}
.chr-card-tour h4 {
  color:#002861;
  font-size:1.2rem;
}
.chr-card-tour h5{
  font-size: 1rem;
  color: #002861;
  border-bottom: 1px solid #002861;
  font-style: italic;
}

.chr-card-tour .chr-text-info {
  color:#002861;
}
.chr-card-tour  h6{
  color:rgb(233, 57, 0);
  border-bottom: 1px solid rgb(233, 57, 0);
}
.chr-card-tour .tour-price {
  color:rgb(233, 57, 0);
}
.chr-card-tour .tour-name {
  text-align: center;
  font-style:italic ;
  font-size: .875rem;
  background: #002861;
  padding: 0.5rem;
  color: #fff;
  margin-bottom: 0;
  border-top: 2px solid rgb(233, 57, 0);
}
.chr-card-tour .full-price {
  text-decoration: line-through;
}
</style>
